<template>
  <div class="mail">
    <div class="form">
      <MailSignIn v-if="flag.type == 'SignIn'" />
      <MailSignUp v-else />
    </div>
    <div class="btn-message">
      <button type="button" name="button" @click="changeFlag">{{ flag.messageJa }}</button>
    </div>
  </div>
</template>
<script>
import MailSignIn from '@/components/Auth/MailSignIn.vue'
import MailSignUp from '@/components/Auth/MailSignUp.vue'



export default {
  name: 'Mail',
  components: {
    MailSignIn,
    MailSignUp
  },
  data(){
    return {
      flags: [
        {
          type: 'SignIn',
          messageJa: 'アカウントをお持ちでない方はこちらをクリック',
          messageEn: 'Click here if you do not have an account.'
        },
        {
          type: 'SignUp',
          messageJa: '既にアカウントをお持ちの方はこちらをクリック',
          messageEn: 'Click here if you already have an account.'
        }
      ],
      flag: null,
      flag_index: 0
    }
  },
  methods: {
    changeFlag(){
      this.flag_index = Number(!this.flag_index);
      this.flag = this.flags[this.flag_index];
    }
  },
  created() {
    this.flag = this.flags[1];
    // this.flags[0].message = parent.$t('auth.message.noAccount');
    // this.flags[1].message = parent.$t('auth.message.haveAccount');

  }
}
</script>
<style scoped>
.btn-message {
  margin-top: 10px;
}

.form {
  border: ridge;
  padding: 10px;
  margin-left: 10px;
  margin-right: 10px;

}
</style>
